import { FiArchive } from 'react-icons/fi';
import { PendingOrderStatus } from '../models/order';
import FilterTable, { BaseData } from './Table/Table';
import EmptyTable from './Table/EmptyTable';
import OrderItem from '../types/OrderItem';

interface TableRow extends BaseData {
  name: string;
  email: JSX.Element;
  pending_status: JSX.Element;
}

const PendingPaymentsTable = ({ orders }: { orders: OrderItem[] }) => {
  const getStatusLabel = (status: PendingOrderStatus) => {
    switch (status) {
      case PendingOrderStatus.no_reminder:
        return <div className="tag-warning">No notificado</div>;
      case PendingOrderStatus.purchased_without_reminder:
        return <div className="tag-primary">Comprado sin notificación</div>;
      case PendingOrderStatus.first_reminder:
        return <div className="tag-warning">Notificado 1 vez</div>;
      case PendingOrderStatus.second_reminder:
        return <div className="tag-warning">Notificado 2 veces</div>;
      case PendingOrderStatus.third_reminder:
        return <div className="tag-warning">Notificado 3 veces</div>;
      case PendingOrderStatus.purchased_after_first:
        return <div className="tag-primary">Comprado después de la primera notificación</div>;
      case PendingOrderStatus.purchased_after_second:
        return <div className="tag-primary">Comprado después de la segunda notificación</div>;
      case PendingOrderStatus.purchased_after_third:
        return <div className="tag-primary">Comprado después de la tercera notificación</div>;
      case PendingOrderStatus.did_not_purchase:
        return <div className="tag-warning">No compró</div>;
      default:
        return <div className="tag-warning">No notificado</div>;
    }
  };

  const tableRows: TableRow[] = orders.map((order) => ({
    id: order.id,
    name: order.ticket_name || '',
    email: <div className="whitespace-nowrap">{order.email}</div>,
    pending_status: <div className="whitespace-nowrap">{getStatusLabel(order.order_pending_status || PendingOrderStatus.no_reminder)}</div>,
  }));

  const headCells = [
    { id: 'name', label: 'Nombre' },
    { id: 'email', label: 'Email' },
    { id: 'pending_status', label: 'Estado de notificación' },
  ];

  return (
    <div>
      {orders.length > 0 ? <FilterTable
        rows={tableRows}
        headCells={headCells}
        pagination={{ enabled: true, pageSize: 10 }}
        searchEnabled={true}
        tableId="pending-orders-table"
      /> : <EmptyTable
        title="No hay pagos pendientes"
        info="No hay pagos pendientes"
        icon={FiArchive}
        iconColor="text-secondary-500"
      />}
    </div>
  );
};

export default PendingPaymentsTable;
